<template>
    <div class="information">
        <!-- <el-card> -->
            <div class="contain">
                <div v-for="item in memberEditData.children" :key="item.nodeCode">
                    <basicInformation
                        ref="basicInformation"
                        :memberId="memberId"
                        v-if="item.nodeName === '基本信息'"
                        :storeList="storeList"
                        :type="type"
                        :memberEditData="memberEditData.memberInfo"
                        :visitDetail="item.children"
                        :id="id"
                        :path="path"
                    ></basicInformation>
                    <living-habit
                        ref="living-habit"
                        :type="type"
                        :memberId="memberId"
                        :visitDetail="item.children"
                        v-else-if="item.nodeName === '生活习惯'"
                    ></living-habit>
                </div>
                <el-card class="box-card">
                  <div slot="header">
                    <h4>其他信息</h4>
                  </div>
                  <el-form ref="formInline" :inline="false" :rules="rules" :model="formInline" class="demo-form-inline">
                    <el-form-item v-if="enterpriseType === 1" label="门店:" prop="storeId">
                      <el-select @change="selectChange" :filterable="true" v-model="formInline.storeId">
                        <el-option v-for="item in storeList" :key="item.id" :label="item.storeName" :value="item.id"></el-option>
                      </el-select>
                    </el-form-item>
                  <el-form-item label="慢病标签:" prop="checkList">
                    <el-checkbox-group @change="checkboxChange" v-model="formInline.checkList">
                      <el-checkbox v-for="item in memberLabelList" :key="item.id" :label="item.id">{{item.labelName}}</el-checkbox>
                    </el-checkbox-group>
                  </el-form-item>
                  <el-form-item label="档案图片:" prop="imageArr">
                    <uploadImg :imgLength="9" :imageArr="formInline.imageArr"></uploadImg>
                  </el-form-item>
                </el-form>
                </el-card>
                <div class="submit-btn">
                    <el-button :loading="loading" type="primary" @click="handleSubmit">提交</el-button>
                </div>
            </div>
        <!-- </el-card> -->
        <!-- 展示图片 -->
        <el-dialog title="查看图片" :visible.sync="open" width="500px">
            <el-image style="width: 100px; height: 100px" v-for="(item, index) in imgs" :key="index" :src="item" :preview-src-list="imgs">
            </el-image>
        </el-dialog>
    </div>
</template>
<script>
import basicInformation from '@/components/common/user/formOfInformation/basicInformation.vue';
import livingHabit from '@/components/common/user/formOfInformation/livingHabit.vue';
import treatHistory from '@/components/common/user/formOfInformation/treatHistory.vue';
import medicalExaminationReport from '@/components/common/user/formOfInformation/medicalExaminationReport.vue';
import uploadImg from '@/components/common/user/uploadImage'
import { memberMedicExaminationReportListByMember, memberTreatmentHistoryListByMember } from '@/api/system/member';
import { memberArchiveDetail, listTreeWithConfig } from '@/api/system/member';
import {  getMemberLabelList, createMember, storeList } from "@/api/system/member";
import {getDate} from '@/utils'
export default {
    components: {
        basicInformation,
        livingHabit,
        treatHistory,
        medicalExaminationReport,
        uploadImg
    },
    props: {
      isShow: {
        type: Boolean,
        required: true
      },
        path: {
            type: String,
            default() {
                return 'informationAdd';
            }
        },
        type: {
            // 1 详情 2 编辑 3 新增
            default: 1,
            type: Number
        },
        // storeList: {
        //     // 门店列表
        //     default() {
        //         return [];
        //     },
        //     type: Array
        // },
        id: {
            // 工单列表id
            default: null,
            type: Number
        },
        // memberId: {
        //     type: null,
        //     // required: true
        //     default() {
        //         return null;
        //     }
        // }
    },
    watch: {
        type: {
            handler: function (val) {
                if (this.activeName === 'treat') {
                    this.handleMemberTreatmentHistoryListByMember(this.memberId);
                } else if (this.activeName === 'report') {
                    this.handleMemberMedicExaminationReportListByMember(this.memberId);
                }
            },
            immediate: true
        },
      isShow(val) {
        if(!val) {
          this.$refs['basicInformation'][0].reset()
          this.$refs['living-habit'][0].reset()
          this.$refs['formInline'].resetFields()
        }
      }
    },
    data() {
        return {
          enterpriseType: parseInt(localStorage.getItem('enterpriseType')),
          loading: false,
          rules: {
            imageArr: [{required: true, message: '不能为空', trigger: 'change'}],
            checkList: [{required: true, message: '不能为空', trigger: 'change'}],
            storeId: [{required: true, message: '不能为空', trigger: 'change'}]
          },
          open: false,
          memberMedicExaminationReportList: [],
          memberTreatmentHistoryList: [],
          activeName: 'baseInfo',
          memberEditData: {},
          memberId: 0,
          memberLabelList: [],
          formInline: {
            checkList: [],
            imageArr: [],
            storeId: undefined
          },
          changeList: [],
          storeList: [],
          storeName: ''
        };
    },
    computed: {
        imgs() {
            if (this.memberEditData?.memberInfo?.archiveImgUrl) {
                return this.memberEditData?.memberInfo?.archiveImgUrl.split(',');
            } else {
                return [];
            }
        },
        isShowBadge() {
            if (this.memberEditData?.memberInfo?.archiveImgUrl) {
                return true;
            } else {
                return false;
            }
        },
        title() {
            return this.type === 1 ? '编辑信息' : '返回';
        }
    },
    created() {
        this.type !== 3 ? this.handleMemberArchiveDetail(this.memberId) : this.handleListTreeWithConfig();
        this.handleMemberLabelList()
        this.handleStoreList()
    },
    methods: {
      /**
       * 选择器change事件
       * @param {Number} data 选择的门店id
       */
      selectChange(data) {
        // console.log(data);
        const result = this.storeList.find(item => {
          return item.id === data
        })
        if(result) {
           this.storeName = result.storeName
        }else {
          this.storeName = ''
        }
      },
      /**
       * 获取所有的门店列表
       */
      handleStoreList() {
        const enterpriseInfo = JSON.parse(localStorage.getItem('enterpriseInfo'))
        // console.log({enterpriseInfo});
        storeList({enterpriseId: enterpriseInfo.id}).then(res => {
          if(res.code === 200) {
            this.storeList = res.rows || []
          }
        })
      },
      /**
       * 多选框change事件
       * @param 
       */
      checkboxChange(data) {
        console.dir({data})
        this.changeList = this.memberLabelList.filter(item => {
          return data.includes(item.id)
        })
        // console.log(list);
      },
      /**
       * 查询慢病标签
       */
      handleMemberLabelList() {
        // debugger
        getMemberLabelList({}).then(res => {
          if(res.code === 200) {
            this.memberLabelList = res.data?res.data: []
          }
        })
      },
      /**
       * 获取对象数据中的基础类型数据
       * @param {Object} data 对象数据
       * @returns 返回
       */
      getBasicData(data) {
        const obj = {}
        for(let key in data) {
          if(typeof data[key] !== 'object') {
            obj[key] = data[key]
          }
        }
        return obj
      },
      /**
       * 表单提交
       */
      handleSubmit() {
        // 对子组件表单进行非空校验
         this.$refs['basicInformation'][0].checkForm().then(res => {
          let children = res
          // 其他信息表单校验
          this.$refs['formInline'].validate((valid) => {
          if (valid) {
            this.loading = true
            const memberLabelVO = {
              memberLabelIds: this.changeList.map(item=>item.id),
              memberLabelNames: this.changeList.map(item=>item.labelName)
            }
            console.dir(this.$refs['basicInformation'][0].$refs['ruleForm']);
            const { ruleForm} = this.$refs['basicInformation'][0]
            const { formatData } = this.$refs['living-habit'][0]
            const children02 = formatData(this.$refs['living-habit'][0].ruleForm)
            const lastLoginDate = getDate('yyyy-MM-dd',new Date().getTime(),false) 
            const memberInfo = this.getBasicData(ruleForm)
            if(memberLabelVO.memberLabelIds.length) {
              memberInfo.memberType = 2
            }else {
              memberInfo.memberType = 1
            }
            memberInfo.lastLoginDate = lastLoginDate
            memberInfo.archiveImgUrl = this.formInline.imageArr.join(',')
            const arr = children02.concat(children)
            const enterpriseInfo = JSON.parse(localStorage.getItem('enterpriseInfo'))
            const enterpriseType = parseInt(localStorage.getItem('enterpriseType'))
            let storeId = null
            let storeName = null
            if(enterpriseType === 1) {
              storeId = this.formInline.storeId
              storeName = this.storeName
            }else {
              storeId = JSON.parse(localStorage.getItem('loginData')).storeId
              storeName = JSON.parse(localStorage.getItem('loginData')).storeNames
            }
            const data = {
              memberInfo,
              archiveRecord:{
                children: arr
              },
              memberLabelVO,
              memberEnterpriseStoreRelation: {
                enterpriseName: enterpriseInfo.enterpriseName,
                enterpriseId: enterpriseInfo.id,
                storeId,
                storeName
              }
            }
            console.log(data);
            createMember(data).then(res => {
              this.$message.success('新增成功!')
              this.$emit('success',false)
              // this.$emit('success')
            }).finally(err=>{
              this.loading = false
            })
          } else {
            // console.log('error submit!!');
            this.$message.warning('表单尚未填写完整')
            return false;
          }
        });
        }).catch(err=> {
          console.log(err);
          this.$message.error(err)
        })
      },
        // 获取用户档案信息
        handleMemberArchiveDetail(id) {
            memberArchiveDetail(id).then((res) => {
                if (res.code === 200) {
                    if (res.data) {
                        this.memberEditData = res.data;
                    } else {
                        this.handleListTreeWithConfig(id);
                    }
                }
            });
        },
        // 获取用户档案树形配置表
        handleListTreeWithConfig(id) {
            listTreeWithConfig(id).then((res) => {
                if (res.code === 200) {
                    this.memberEditData = {
                        children: res.data
                    };
                }
            });
        },
        success(type) {
            if (type === 'Treatment') {
                this.handleMemberTreatmentHistoryListByMember(this.memberId);
            } else {
                this.handleMemberMedicExaminationReportListByMember(this.memberId);
            }
        },
        // 获取治疗历史
        handleMemberTreatmentHistoryListByMember(id) {
            memberTreatmentHistoryListByMember(id).then((res) => {
                if (res.code === 200) {
                    this.memberTreatmentHistoryList = res.data;
                }
            });
        },
        // 获取会员检查报告
        handleMemberMedicExaminationReportListByMember(id) {
            memberMedicExaminationReportListByMember(id).then((res) => {
                if (res.code === 200) {
                    this.memberMedicExaminationReportList = res.data;
                }
            });
        },
        // tabs点击事件
        tabClick(val) {
            // console.log('val====>', val);
            if (val.label === '治疗历史') {
                this.handleMemberTreatmentHistoryListByMember(this.memberId);
            } else {
                this.handleMemberMedicExaminationReportListByMember(this.memberId);
            }
        },
        handleChange() {},
        onCancel() {
            this.$emit('handleEdit', this.type === 1 ? 2 : 1);
        },
        isActive(route) {
            return route.path === this.$route.path;
        }
    }
};
</script>
<style lang="less" scoped>
.contain ::v-deep .box-card {
  margin-bottom: 10px;
}
.contain {
  padding-bottom: 100px;
}
.submit-btn {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 10px;
    z-index: 9999;
    text-align: center;
    background-color: white;
    padding: 10px 20px 10px;
    border: 1px solid rgb(243, 237, 237);
}
.badge ::v-deep .el-button {
    padding: 0;
}
.content ::v-deep .box-card {
    margin-bottom: 16px;
}
.btn {
    margin: 20px;
    width: calc(100% - 40px);
    text-align: center;
}
.content {
    height: 450px;
    // overflow: auto;
    /deep/ .el-scrollbar__wrap {
        overflow-x: hidden !important;
    }
}
.information /deep/ .el-collapse-item__header {
    background: #e6ebf5;
    padding-left: 10px;
    font-weight: bold;
}
.slot_title {
    display: flex;
    align-items: center;
    p:nth-child(1) {
        width: 4px;
        height: 22px;
        background: #46a6ff;
        border-radius: 6px;
        margin-right: 10px;
    }
}
.person_info {
    //   padding: 20px;
    //   padding-left: 50px;
    //   margin-bottom: 20px;
    .header {
        display: flex;
        // justify-content: space-between;
        align-items: center;
        padding: 10px 4px;
        background: #e8f4ff;
        h4 {
            margin: 0;
            padding: 0;
            margin-right: 20px;
        }
    }
    h4 {
        // margin: 0;
        padding: 10px 4px;
        background: #e8f4ff;
        font-weight: normal;
    }
    .item {
        display: flex;
        // justify-content: space-between;
        width: 100%;
        align-items: center;

        p {
            width: 50%;
            font-size: 14px;
            //   padding-right: 100px;
            display: flex;
            flex-wrap: nowrap;
            align-items: center;
            span:nth-child(1) {
                display: inline-block;
                width: 100px;
                text-align: left;
                /deep/ .el-tag--medium {
                    margin-right: 10px;
                }
                // margin-right: 10px;
            }
            .require:before {
                content: '*';
                color: #f56c6c;
                margin-right: 4px;
            }
            /deep/ .el-input {
                width: 50%;
            }
        }
        .store {
            /deep/ .el-input {
                width: 100%;
            }
        }
        .remark {
            width: 100%;
        }
    }
}
.footer {
    padding: 20px;
    //   padding-left: 50px;
    .img {
        width: 100px;
        height: 100px;
        margin-right: 20px;
    }
}
.tip {
    color: #f56c6c;
    margin-left: 10px;
}
</style>
